import {createAction, props} from '@ngrx/store';
import {
  CategoriesResponse,
  ResourceDetails,
  ResourceResponseData,
  Resource,
  Role,
  Session
} from '../model/resource-model';
import {
  ResourcesResponse,
  SubCategoriesList
} from '../model/resource-details.model';
import {DropdownOption} from "../../../../models/dropdown-option.model";
import {Filter} from "../../../../models/filter";

/******** CLEAR STATE ***********/
const CLEAR_STATE = '[resources-hub] clear state';
export const ClearState = createAction(CLEAR_STATE);

/******** RESOURCE DETAILS ACTIONS ***********/
const GET_RESOURCE_DETAILS_REQUEST = '[resources-hub] get resource details request';
export const GetResourceDetailRequest = createAction(GET_RESOURCE_DETAILS_REQUEST, props<{
  payload: {
    resourceId: string,
    slug: string
  }
}>());

const GET_RESOURCE_DETAILS_SUCCESS = '[resources-hub] get resource details success';
export const GetResourceDetailSuccess = createAction(GET_RESOURCE_DETAILS_SUCCESS, props<{
  data: ResourceDetails
}>());

const GET_RESOURCE_DETAILS_FAILURE = '[resources-hub] get resource details failure';
export const GetResourceDetailFailure = createAction(GET_RESOURCE_DETAILS_FAILURE, props<{
  error: any
}>());

const UPDATE_HERO_SECTION_DETAILS_ADD_RESOURCES = '[resources-hub] update hero section details add resource'
export const UpdateHeroSectionDetailsAddResources = createAction(UPDATE_HERO_SECTION_DETAILS_ADD_RESOURCES, props<{
  data: any
}>())

const UPDATE_SECTION_DETAILS_ADD_RESOURCES = '[resources-hub] update section details add resources'
export const UpdateSectionDetailsAddResources = createAction(UPDATE_SECTION_DETAILS_ADD_RESOURCES, props<{
  section: any
}>())

//fetch session list
const FETCH_SESSION_LIST_REQUEST = '[resources-hub] fetch session list request'
export const FetchSessionListRequest = createAction(FETCH_SESSION_LIST_REQUEST)

const FETCH_SESSION_LIST_SUCCESS = '[resources-hub] fetch session list success'
export const FetchSessionListSuccess = createAction(FETCH_SESSION_LIST_SUCCESS, props<{
  sessionList: Session[]
}>())

const FETCH_SESSION_LIST_FAILURE = '[resources-hub] fetch session list failure'
export const FetchSessionListFailure = createAction(FETCH_SESSION_LIST_FAILURE, props<{
  error: any
}>())


//fetch role list
const FETCH_ROLE_LIST_REQUEST = '[resources-hub] fetch role list request'
export const FetchRolesListRequest = createAction(FETCH_ROLE_LIST_REQUEST)

const FETCH_ROLE_LIST_SUCCESS = '[resources-hub] fetch role list success'
export const FetchRolesListSuccess = createAction(FETCH_ROLE_LIST_SUCCESS, props<{
  roleList: {
    hasNext?: boolean,
    hasPrev?: boolean,
    limit?: number,
    list?: Role[],
    pageNumber?: number,
    total?: number
  }
}>())

const FETCH_ROLE_LIST_FAILURE = '[resources-hub] fetch role list failure'
export const FetchRolesListFailure = createAction(FETCH_ROLE_LIST_FAILURE, props<{
  error: any
}>())

//fetch categories list
const FETCH_CATEGORIES_LIST_REQUEST = '[resources-hub] fetch categories list request'
export const FetchCategoriesListRequest = createAction(FETCH_CATEGORIES_LIST_REQUEST);
const FETCH_CATEGORIES_LIST_SUCCESS = '[resources-hub] fetch categories list success'
export const FetchCategoriesListSuccess = createAction(FETCH_CATEGORIES_LIST_SUCCESS, props<{
  categories: CategoriesResponse[]
}>());
const FETCH_CATEGORIES_LIST_FAILURE = '[resources-hub] fetch categories list failure'
export const FetchCategoriesListFailure = createAction(FETCH_CATEGORIES_LIST_FAILURE);


//fetch subcategories list
const FETCH_SUB_CATEGORIES_LIST_REQUEST = '[resources-hub] fetch sub categories list request';
export const FetchSubCategoriesListRequest = createAction(FETCH_SUB_CATEGORIES_LIST_REQUEST, props<{
  payload: {
    categoryId: number,
    categoriesData?: CategoriesResponse[]
  }
}>())
const FETCH_SUB_CATEGORIES_LIST_SUCCESS = '[resources-hub] fetch sub categories list success';
export const FetchSubCategoriesListSuccess = createAction(FETCH_SUB_CATEGORIES_LIST_SUCCESS, props<{
  subCategoriesList: CategoriesResponse[]
}>())
const FETCH_SUB_CATEGORIES_LIST_FAILURE = '[resources-hub] fetch sub categories list failure'
export const FetchSubCategoriesListFailure = createAction(FETCH_SUB_CATEGORIES_LIST_FAILURE)

// fetch resources
const FETCH_RELATED_RESOURCES_LIST_REQUEST = '[resources-hub] fetch related resources list request'
export const FetchRelatedResourcesRequest = createAction(FETCH_RELATED_RESOURCES_LIST_REQUEST, props<{
  payload: ResourcesResponse['request']
}>())
const FETCH_RELATED_RESOURCES_LIST_SUCCESS = '[resources-hub] fetch related resources list success'
export const FetchRelatedResourcesSuccess = createAction(FETCH_RELATED_RESOURCES_LIST_SUCCESS, props<{
  resources: ResourceResponseData
}>())
const FETCH_RELATED_RESOURCES_LIST_FAILURE = '[resources-hub] fetch related resources list failure'
export const FetchRelatedResourcesFailure = createAction(FETCH_RELATED_RESOURCES_LIST_FAILURE)


// publish resource actions
const SAVE_OR_PUBLISH_RESOURCE_REQUEST = '[resources-hub] save or publish resource request'
export const SaveOrPublishResourceRequest = createAction(SAVE_OR_PUBLISH_RESOURCE_REQUEST, props<{
  payload: {
    resource: ResourceDetails
  }
}>())
const SAVE_OR_PUBLISH_RESOURCE_SUCCESS = '[resources-hub] save or publish resource success'
export const SaveOrPublishResourceSuccess = createAction(SAVE_OR_PUBLISH_RESOURCE_SUCCESS, props<{
  payload: {
    resource: ResourceDetails,
    message: string
  }
}>())
const SAVE_OR_PUBLISH_RESOURCE_FAILURE = '[resources-hub] save or publish resource failure'
export const SaveOrPublishResourceFailure = createAction(SAVE_OR_PUBLISH_RESOURCE_FAILURE)

//fetchResourceDetailsForEdit
const FETCH_RESOURCE_DETAILS_FOR_EDIT_REQUEST = '[resources-hub] fetch resource details for edit request'
export const FetchResourceDetailsForEditRequest = createAction(FETCH_RESOURCE_DETAILS_FOR_EDIT_REQUEST, props<{
  payload: {
    resourceId: string,
    slug: string
  }
}>())
const FETCH_RESOURCE_DETAILS_FOR_EDIT_SUCCESS = '[resources-hub] fetch resource details for edit success'
export const FetchResourceDetailsForEditSuccess = createAction(FETCH_RESOURCE_DETAILS_FOR_EDIT_SUCCESS, props<{
  resourceDetails: ResourceDetails
}>())
const FETCH_RESOURCE_DETAILS_FOR_EDIT_FAILURE = '[resources-hub] fetch resource details for edit failure'
export const FetchResourceDetailsForEditFailure = createAction(FETCH_RESOURCE_DETAILS_FOR_EDIT_FAILURE)


// delete Resource
const DELETE_RESOURCE_REQUEST = '[resources-hub] delete resource request'
export const DeleteResourceRequest = createAction(DELETE_RESOURCE_REQUEST, props<{
  payload: {
    resourceId: string
  }
}>())
const DELETE_RESOURCE_SUCCESS = '[resources-hub] delete resource success'
export const DeleteResourceSuccess = createAction(DELETE_RESOURCE_SUCCESS, props<{
  payload: {
    message: string
  }
}>())
const DELETE_RESOURCE_FAILURE = '[resources-hub] delete resource failure'
export const DeleteResourceFailure = createAction(DELETE_RESOURCE_FAILURE)

//fetch session list for resource list
const FETCH_SESSION_lIST_RESOURCE_LIST_REQUEST = '[resources-hub] fetch session list resource list request'
export const FetchSessionListResourceListRequest = createAction(FETCH_SESSION_lIST_RESOURCE_LIST_REQUEST)
const FETCH_SESSION_lIST_RESOURCE_LIST_SUCCESS = '[resources-hub] fetch session list resource list success'
export const FetchSessionListResourceListSuccess = createAction(FETCH_SESSION_lIST_RESOURCE_LIST_SUCCESS, props<{
  payload: {
    sessionList: Session[]
  }
}>())
const FETCH_SESSION_lIST_RESOURCE_LIST_FAILURE = '[resources-hub] fetch session list resource list failure'
export const FetchSessionListResourceListFailure = createAction(FETCH_SESSION_lIST_RESOURCE_LIST_FAILURE)


//fetch roles list for resource list
const FETCH_ROLES_LIST_RESOURCE_LIST_REQUEST = '[resources-hub] fetch roles list resource list request'
export const FetchRolesListResourceListRequest = createAction(FETCH_ROLES_LIST_RESOURCE_LIST_REQUEST)
const FETCH_ROLES_LIST_RESOURCE_LIST_SUCCESS = '[resources-hub] fetch roles list resource list success'
export const FetchRolesListResourceListSuccess = createAction(FETCH_ROLES_LIST_RESOURCE_LIST_SUCCESS, props<{
  payload: {
    roleList: {
      hasNext?: boolean,
      hasPrev?: boolean,
      limit?: number,
      list?: Role[],
      pageNumber?: number,
      total?: number
    }
  }
}>())
const FETCH_ROLES_LIST_RESOURCE_LIST_FAILURE = '[resources-hub] fetch roles list resource list failure'
export const FetchRolesListResourceListFailure = createAction(FETCH_ROLES_LIST_RESOURCE_LIST_FAILURE)

//fetch categories for resource list
const FETCH_CATEGORIES_LIST_RESOURCE_LIST_REQUEST = '[resources-hub] fetch categories list resource list request'
export const FetchCategoriesListResourceListRequest = createAction(FETCH_CATEGORIES_LIST_RESOURCE_LIST_REQUEST)
const FETCH_CATEGORIES_LIST_RESOURCE_LIST_SUCCESS = '[resources-hub] fetch categories list resource list success'
export const FetchCategoriesListResourceListSuccess = createAction(FETCH_CATEGORIES_LIST_RESOURCE_LIST_SUCCESS, props<{
  payload: {
    categories: CategoriesResponse[]
  }
}>())
const FETCH_CATEGORIES_LIST_RESOURCE_LIST_FAILURE = '[resources-hub] fetch categories list resource list failure'
export const FetchCategoriesListResourceListFailure = createAction(FETCH_CATEGORIES_LIST_RESOURCE_LIST_FAILURE)

//fetch sub categories for resource list
const FETCH_SUB_CATEGORIES_LIST_RESOURCE_LIST_REQUEST = '[resources-hub] fetch sub categories list resource list request'
export const FetchSubCategoriesListResourceListRequest = createAction(FETCH_SUB_CATEGORIES_LIST_RESOURCE_LIST_REQUEST, props<{
  payload: SubCategoriesList['request']
}>())
const FETCH_SUB_CATEGORIES_LIST_RESOURCE_LIST_SUCCESS = '[resources-hub] fetch sub categories list resource list success'
export const FetchSubCategoriesListResourceListSuccess = createAction(FETCH_SUB_CATEGORIES_LIST_RESOURCE_LIST_SUCCESS, props<{
  payload: {
    subCategories: DropdownOption[]
  }
}>())
const FETCH_SUB_CATEGORIES_LIST_RESOURCE_LIST_FAILURE = '[resources-hub] fetch sub categories list resource list failure'
export const FetchSubCategoriesListResourceListFailure = createAction(FETCH_SUB_CATEGORIES_LIST_RESOURCE_LIST_FAILURE)


//fetch resource list
const FETCH_RESOURCE_LIST_REQUEST = '[resources-hub] fetch resource list request'
export const FetchResourceListRequest = createAction(FETCH_RESOURCE_LIST_REQUEST, props<{
  payload: ResourcesResponse['request']
}>())
const FETCH_RESOURCE_LIST_SUCCESS = '[resources-hub] fetch resource list success'
export const FetchResourceListSuccess = createAction(FETCH_RESOURCE_LIST_SUCCESS, props<{
  data: ResourceResponseData
}>())
const FETCH_RESOURCE_LIST_FAILURE = '[resources-hub] fetch resource list failure'
export const FetchResourceListFailure = createAction(FETCH_RESOURCE_LIST_FAILURE)

//fetch resource status
const FETCH_RESOURCE_STATUS_REQUEST = '[resources-hub] fetch resource status request'
export const FetchResourceStatusRequest = createAction(FETCH_RESOURCE_STATUS_REQUEST)

const FETCH_RESOURCE_STATUS_SUCCESS = '[resources-hub] fetch resource status success'
export const FetchResourceStatusSuccess = createAction(FETCH_RESOURCE_STATUS_SUCCESS, props<{
  payload: {
    statusList: DropdownOption[]
  }
}>())

const FETCH_RESOURCE_STATUS_FAILURE = '[resources-hub] fetch resource status failure'
export const FetchResourceStatusFailure = createAction(FETCH_RESOURCE_STATUS_FAILURE)


//fetch organisations list
const FETCH_ORGANISATIONS_LIST_REQUEST = '[resources-hub] fetch organisations list request'
export const FetchOrganisationsListRequest = createAction(FETCH_ORGANISATIONS_LIST_REQUEST)
const FETCH_ORGANISATIONS_LIST_SUCCESS = '[resources-hub] fetch organisations list success'
export const FetchOrganisationsListSuccess = createAction(FETCH_ORGANISATIONS_LIST_SUCCESS, props<{
  organisationsList: any[]
}>())
const FETCH_ORGANISATIONS_LIST_FAILURE = '[resources-hub] fetch organisations list failure'
export const FetchOrganisationsListFailure = createAction(FETCH_ORGANISATIONS_LIST_FAILURE)

//fetch groups list
const FETCH_GROUPS_LIST_REQUEST = '[resources-hub] fetch groups list request'
export const FetchGroupsListRequest = createAction(FETCH_GROUPS_LIST_REQUEST, props<{
  payload?: any
}>())
const FETCH_GROUPS_LIST_SUCCESS = '[resources-hub] fetch groups list success'
export const FetchGroupsListSuccess = createAction(FETCH_GROUPS_LIST_SUCCESS, props<{
  groupsList: any[]
}>())
const FETCH_GROUPS_LIST_FAILURE = '[resources-hub] fetch groups list failure'
export const FetchGroupsListFailure = createAction(FETCH_GROUPS_LIST_FAILURE)

const CLEAR_SELECTED_RESOURCE = '[resources-hub] clear selected resource'
export const ClearSelectedResource = createAction(CLEAR_SELECTED_RESOURCE)
